import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconLinkStyle0 = cosmosIconCss;

const CosmosIconLink$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconLink extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '4ce81f54fc8318b9d3de691f3353371bd9a2e29e', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: 'e3ab5a034c2764ef133ff30a17c7881366547d85', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '8fdf62233dcd89f291ad1d266300e0cbbffd418c', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M14.496 3.434A4 4 0 0 1 17.29 4.78a4 4 0 0 1 .28 5.74l-2.62 2.63a3.43 3.43 0 0 1-2.44 1 4.42 4.42 0 0 1-2.77-1.06.5.5 0 0 1 0-.73l.37-.36a.48.48 0 0 1 .66 0 2.32 2.32 0 0 0 3.13.06l2.63-2.62a2.53 2.53 0 0 0-.3-3.59 2.53 2.53 0 0 0-3.59-.3l-.66.67a.52.52 0 0 1-.72 0l-.35-.36a.5.5 0 0 1 0-.71l.67-.66a4 4 0 0 1 2.916-1.056ZM7.72 17.11a2.13 2.13 0 0 0 1.65-.61l.65-.64a.49.49 0 0 1 .7 0l.36.35a.5.5 0 0 1 0 .71l-.64.64a3.68 3.68 0 0 1-2.62 1.05h-.16a4.45 4.45 0 0 1-2.94-1.34 4 4 0 0 1-.3-5.72l2.65-2.58a3.79 3.79 0 0 1 5.2.06.5.5 0 0 1 0 .73l-.36.36a.5.5 0 0 1-.67 0A2.34 2.34 0 0 0 8.11 10l-2.63 2.61a2.54 2.54 0 0 0 .3 3.6 3 3 0 0 0 1.94.9Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconLinkStyle0; }
}, [1, "cosmos-icon-link", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-link"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-link":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconLink$1);
            }
            break;
    } });
}

const CosmosIconLink = CosmosIconLink$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconLink, defineCustomElement };
